import { Table, TableBody, TableHead, TableRow } from '@mui/material';

import {
  GeneralTableBox,
  NoDataSkeleton,
  PaginationTable,
  RowTableCell,
  SortableHeadTableCell,
  TableBodySkeleton,
} from '../../../common/components';
import { materialCell } from '../../../utils/materialDisplay';
import { SERVER_ROWS_PER_PAGE_OPTIONS } from '../../../common/constants/paginationConstants';

/**
 * Tabla de fuentes anteriores al costeo (compras o retornos) que necesitan una fuente aprobada.
 * @param {Object} props
 * @param {Array<Object>} props.rows Renglones de la página.
 * @param {Array<{key: string, label: string, numeric?: boolean, width?: number}>} props.columns
 *   Columnas; las que no indican `width` reparten el espacio libre.
 * @param {number} props.totalCount Total de renglones.
 * @param {number} props.page Página actual.
 * @param {Function} props.onPageChange Cambia de página.
 * @param {boolean} props.isLoading Carga inicial.
 * @param {string} props.emptyMessage Mensaje sin datos.
 * @param {{key: string, direction: string}|null} props.sort Orden vigente.
 * @param {Function} props.onSort Recibe la columna clickeada.
 * @returns {JSX.Element}
 */
const MaterialPreflightTable = ({
  rows,
  columns,
  totalCount,
  page,
  rowsPerPage,
  onRowsPerPageChange,
  onPageChange,
  isLoading,
  emptyMessage,
  sort,
  onSort,
}) => (
  <>
    <GeneralTableBox fixedLayout>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <SortableHeadTableCell
                key={column.key}
                sortKey={column.key}
                sort={sort}
                onSort={onSort}
                sx={{ textAlign: column.numeric ? 'right' : 'left', width: column.width }}
              >
                {column.label}
              </SortableHeadTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : rows.length ? (
            rows.map((row) => (
              <TableRow key={row.uuid} hover>
                {columns.map((column) => (
                  <RowTableCell
                    key={column.key}
                    sx={{ textAlign: column.numeric ? 'right' : 'left' }}
                    title={column.numeric ? undefined : row[column.key]}
                  >
                    {materialCell(column.key, row[column.key])}
                  </RowTableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={columns.length} message={emptyMessage} />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>

    {totalCount > 0 && (
      <PaginationTable
        page={page}
        totalPages={Math.max(1, Math.ceil(totalCount / rowsPerPage))}
        totalCount={totalCount}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={SERVER_ROWS_PER_PAGE_OPTIONS}
        onRowsPerPageChange={onRowsPerPageChange}
        onPageChange={onPageChange}
      />
    )}
  </>
);

export default MaterialPreflightTable;
